import React, { useState, useEffect } from "react";

const Timer = ({ endDate, status }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    if (status === 1 || !endDate) return null;
    const difference = new Date(endDate) - new Date();
    if (difference <= 0) return null;
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    if (status === 1 || !endDate) return;
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line
  }, [endDate, status]);

  if (status === 1) {
    return <div className="timer">Available</div>;
  }

  if (!endDate) {
    return null;
  }

  if (!timeLeft) {
    return <div className="timer">Available</div>;
  }

  return (
    <div className="timer">
      {timeLeft.days}d : {timeLeft.hours}h : {timeLeft.minutes}m :{" "}
      {timeLeft.seconds}s
    </div>
  );
};

export default Timer;
